import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import userReducer from "./slices/userSlice";
import typeReducer from "./slices/typeSlice";
import otherUserReducer from "./slices/otherUserSlice";
import imgReducer from "./slices/imgSlice";
import myProjectReducer from "./slices/myProjectSlice";
import votingFormReducer from "./slices/votingFormSlice";
import anketReducer from "./slices/anketSlice";
import completeVotingReducer from "./slices/completeVotingSlice";
import leftProjectReducer from "./slices/leftProjectSlice";
import bildirimReducer from "./slices/bildirimSlices";
import mailOnayReducer from "./slices/mailOnaySlice";
import sifremiUnuttumReducer from "./slices/sifremiUnuttumSlice";
import projectReducer from "./slices/projectSlice";
import projectEditReducer from "./slices/projectEditSlice";
import positionReducer from "./slices/positionSlice";
const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    users: typeReducer,
    otherUser: otherUserReducer,
    img: imgReducer,
    myProjects: myProjectReducer,
    votingForm: votingFormReducer,
    anket: anketReducer,
    completeVoting: completeVotingReducer,
    leftProject: leftProjectReducer,
    bildirim: bildirimReducer,
    mailOnay: mailOnayReducer,
    sifremiUnuttum: sifremiUnuttumReducer,
    projects: projectReducer,
    projectEdit: projectEditReducer,
    positions: positionReducer,
  },
});

export default store;
